import { render, staticRenderFns } from "./SestLuvReportsComments.vue?vue&type=template&id=aa64545c&scoped=true"
import script from "./SestLuvReportsComments.vue?vue&type=script&lang=js"
export * from "./SestLuvReportsComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa64545c",
  null
  
)

export default component.exports